interface Segments {
  beginText: string;
  endText: string;
  keyphrase: string;
}

export const parseTextIntoSegments = ({ text, keyphrase }: { text: string; keyphrase: string }): Segments | null => {
  const keyphraseIndex = text.indexOf(keyphrase);

  if (keyphraseIndex === -1) {
    return null;
  }

  const beginText = text.substring(0, keyphraseIndex);
  const endText = text.substring(keyphraseIndex + keyphrase.length, text.length);

  return { beginText, keyphrase, endText };
};

export const scrollToSelectedTab = (tabContainerId?: string) => {
  // since the tab selection is controlled internally to Tabs parent controller, we need to use dom traversal for scrolling selected tab into view.
  if (!tabContainerId) {
    return;
  }

  const tabContainer = document.getElementById(tabContainerId);
  const selectedTab = tabContainer?.querySelector('[aria-selected="true"]');
  selectedTab?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
};
